"use client";

import { usePathname } from "next/navigation";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppButton() {
  const pathname = usePathname();

  const phoneNumber = "919031044412";
  const message = "Hi! I’m interested in the courses offered by Medhavi Skills University.";
  const whatsappUrl = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodeURIComponent(message)}&type=phone_number&app_absent=0`;

  const isCoLedProgram =
    pathname?.includes("industry-co-led-pg-programmes") ||
    pathname?.includes("industry-co-led-ug-programmes");

  // Applies bottom-40 on mobile (< md), bottom-20 on md+ for specific pages
  // For other pages, applies bottom-20 at all screen sizes
  const bottomPosition = isCoLedProgram
    ? "bottom-40 md:bottom-20"
    : "bottom-20";

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed ${bottomPosition} right-5 z-999`}
      aria-label="Chat with us on WhatsApp"
    >
      <div className="flex items-center justify-center w-10 h-10 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg transition duration-300 animate-bounce">
        <FaWhatsapp size={20} />
      </div>
    </a>
  );
}